$(document).ready(function () {
    $('.akkordeon.multiple .akkordeon-header').click(function () {
        $(this).toggleClass('open');
        $(this).next('.akkordeon-content').toggleClass('open');
    });
    $('.akkordeon.single .akkordeon-header').click(function () {
        if ($(this).hasClass('open')) {
            $('.akkordeon-content').removeClass('open');
            $('.akkordeon-header').removeClass('open');
            ;
        } else {
            $('.akkordeon-content').removeClass('open');
            $('.akkordeon-header').removeClass('open');
            $(this).addClass('open');
            $(this).next('.akkordeon-content').addClass('open');
        }
    });

});